import { useContext } from 'react'

import { ConfigContext } from '@/contexts/config'
import { Theme } from '@/types/theme'

interface UseThemeProps {
  theme: Theme | undefined
}

export const useTheme = (): UseThemeProps => {
  const { config } = useContext(ConfigContext)

  return {
    theme: config?.theme
  }
}
